import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgExternalLink = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" role="img" ref={ref} {...props}><g fill="currentColor" fillRule="evenodd"><path d="m13.3 4.457-4.9 4.9-1.929-1.935L11.292 2.6 8.537.05 16 0v6.96zM5.545 0v2.043h-3.5v11.913h11.911V9.67H16V16H0V0z" /><path d="M15.999 0H8.484l7.515 7.515z" /></g></svg>;
const ForwardRef = forwardRef(SvgExternalLink);
export default ForwardRef;